import { render, staticRenderFns } from "./MakeDoctorList.vue?vue&type=template&id=abe71a2a&scoped=true&"
import script from "./MakeDoctorList.vue?vue&type=script&lang=js&"
export * from "./MakeDoctorList.vue?vue&type=script&lang=js&"
import style0 from "./MakeDoctorList.vue?vue&type=style&index=0&id=abe71a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe71a2a",
  null
  
)

export default component.exports